import SessionDetailsModal from "@common/components/modals/SessionDetailsModal";
import DataGrid from "@shared/DataGrid";
import React, { Component } from "react";
import { Grid, Pagination } from "semantic-ui-react";

class BaseTab extends Component {
  state = {
    sessionId: null,
    modalOpen: false,
  };

  handleClose = () => this.setState({ modalOpen: false });

  onPageChange = (event, { activePage }) => this.props.onPageChange(activePage);

  handleOptionChange = (option, value) => {
    const { summary } = this.props.data;
    const data = [...summary.data];

    data.forEach((row, rowIndex) => {
      row.cellData.forEach((cell, cellIndex) => {
        if (cell.data.code === option.code) {
          data[rowIndex].cellData[cellIndex] = {
            ...data[rowIndex].cellData[cellIndex],
            data: { ...option },
          };
        }
      });
    });

    this.props.onOptionChange({ ...summary, data });
  };

  onRowClick = (activeRow) => {
    if (activeRow.sessionId) {
      this.setState({ sessionId: activeRow.sessionId, modalOpen: true });
    }
  };

  render() {
    const { hasSelection } = this.props.filters;
    const showSummary = this.props.view.showSummary && hasSelection;
    const { summary, grid, loading } = this.props.data;
    const { prefix } = this.props;

    const tablet = 6;
    const computer = 6;
    const largeScreen = 5;
    const wideScreen = 4;

    return (
      <Grid className="height-100 gs-flex-container-vertical">
        {prefix && (
          <Grid.Row>
            <Grid.Column width="16">{prefix}</Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row className="flex-stretch">
          {showSummary && (
            <Grid.Column
              computer={computer}
              tablet={tablet}
              largeScreen={largeScreen}
              widescreen={wideScreen}
              className="gs-flex-container-vertical"
            >
              <DataGrid
                loading={loading}
                headings={summary.headerDef}
                data={summary.data}
                rowDef={summary.rowDef}
                disableActiveRow={true}
                fullHeight
                onOptionChange={this.handleOptionChange}
              />
            </Grid.Column>
          )}
          <Grid.Column
            computer={showSummary ? 16 - computer : "16"}
            tablet={showSummary ? 16 - tablet : "16"}
            largeScreen={showSummary ? 16 - largeScreen : "16"}
            widescreen={showSummary ? 16 - wideScreen : "16"}
            className="gs-flex-container-vertical"
          >
            <DataGrid
              loading={loading}
              headings={grid.headerDef}
              data={grid.data}
              onRowClick={this.onRowClick}
              rowDef={grid.rowDef}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="16" textAlign="right">
            <Pagination
              disabled={!hasSelection}
              size="mini"
              defaultActivePage={grid.pageNumber}
              ellipsisItem={null}
              totalPages={grid.pageCount}
              onPageChange={this.onPageChange}
            />
            {this.state.sessionId && (
              <SessionDetailsModal
                modalOpen={this.state.modalOpen}
                handleClose={this.handleClose}
                sessionId={this.state.sessionId}
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default BaseTab;
